export  const btnArray = [
  {
    name: "Все",
    active: "all",
  },
  {
    name: "Новые",
    active: "new",
  },
  {
    name: "В работе",
    active: "inwork",
  },
  {
    name: "Завершенные",
    active: "complete",
  },
];
